<kendo-dialog-titlebar>
    <h4 style="color: var(--tb-kendo-neutral-160)">Assign Action Item</h4>
</kendo-dialog-titlebar>
<app-staff-search #staff (selectedStaffChange)="staffSelected()" (resetSearchChange)="resetSearch($event)"
    [readOnly]="true"></app-staff-search>
<kendo-dialog-actions>
    @if (loadSpinner) {
    <div class="loading-container">
        <kendo-loader type="converging-spinner"></kendo-loader>
    </div>
    }
    <div class="k-d-flex k-justify-content-end k-gap-sm">
        <button kendoButton size="large" rounded="large" fillMode="outline" themeColor="error" (click)="dialog.close()">
            Cancel
        </button>
        &nbsp;
        <button kendoButton size="large" rounded="large" [disabled]="!selectedSearch" fillMode="solid"
            themeColor="primary" (click)="onSubmit()">
            Submit
        </button>
    </div>
</kendo-dialog-actions>